import moment from "moment"
import { RangeDate } from "shared"

const useDates = () => {
  const DATE_FORMAT = 'LL'//'DD MMMM YYYY г.' //'DD/MM/YYYY'
  const DATE_TIME_FORMAT = 'LLL'//'DD MMMM YYYY г., HH:mm' //'DD/MM/YYYY HH:mm'
  const TIME_FORMAT = 'HH:mm'

  const dateFormat = (date: Date | null | undefined) => moment(date).format(DATE_FORMAT)
  const dateTimeFormat = (date: Date | null | undefined) => moment(date).format(DATE_TIME_FORMAT)
  const timeFormat = (date: Date | null | undefined) => moment(date).format(TIME_FORMAT)

  const dateRangeFormat = (dates: RangeDate) => {
    let firstFormat = DATE_FORMAT

    if (moment(dates.start).isSame(moment(dates.end), 'day'))
      return dateFormat(dates.start)
    else if (moment(dates.start).isSame(moment(dates.end), 'month'))
      firstFormat = 'DD'
    else if (moment(dates.start).isSame(moment(dates.end), 'year'))
      firstFormat = 'DD MMMM'

    return `${moment(dates.start).format(firstFormat)} - ${dateFormat(dates.end)}`
  }

  const fromNow = (date: Date | undefined) => moment(date).fromNow()

  return {
    DATE_FORMAT,
    DATE_TIME_FORMAT,
    TIME_FORMAT,
    dateFormat,
    dateTimeFormat,
    timeFormat,
    dateRangeFormat,
    fromNow
  }
}

export {useDates}